import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createInventoryProductsSchemas } from 'shared/db/validation/schema/inventoryProducts';
import { Validator } from 'shared/db/validation/validator';
import {
    InventoryProductRawRecord,
    InventoryProductUpdateRawRecord,
} from 'shared/types/InventoryProduct';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { InventoryProductDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createInventoryProductsSchemas();

const addValidator = createDBEntityValidator<InventoryProductRawRecord>(
    schemas.add,
);
const updateValidator =
    createDBEntityValidator<InventoryProductUpdateRawRecord>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-inventory-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createInventoryProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const inventoryProductsInputValidation: InventoryProductDBValidation = {
    add: createInventoryProductsInputValidation(
        addValidator,
        validationStrategy,
    ),
    update: createInventoryProductsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createInventoryProductsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
